import {filterArrayUndefined} from '@coolcolduk/util';
import {mapExamModuleDbToType, UserPermission, type ExamModule} from '@cp/model';
import {getDocs, orderBy, query, where} from 'firebase/firestore';
import getExamModulesCollection from './getExamModulesCollection';

export default async function listExamModulesDoc(requiredRoles: UserPermission[] = []): Promise<ExamModule[]> {
  const constraints = [
    ...(requiredRoles.length > 0 ? [where('requiredRole', 'in', [...requiredRoles, ''])] : []),
    orderBy('createdAt', 'asc'),
  ];

  const q = query(getExamModulesCollection(), ...constraints);
  const snapshot = await getDocs(q);
  return filterArrayUndefined(snapshot.docs.map((d) => mapExamModuleDbToType(d)));
}
